import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Power3 } from "gsap";


gsap.registerPlugin(ScrollTrigger);



window.addEventListener('load', function() {
    let numFlakes = 23
    let width = window.innerWidth
    let height = window.innerHeight
    const snowContainer = document.getElementById('snowContainer');


    function createFlake() {
        let flake = document.createElement("div")
        let flakeClass = "flake flake" + gsap.utils.random(1, 3, 1)
        flake.setAttribute("class", flakeClass)

        snowContainer.appendChild(flake)
        return flake
    }

    function animateFlake(flake) {

        let scaleFactor = Power3.easeIn(Math.random()) //change to easeOut for more larger flakes
        let scale = gsap.utils.interpolate(0.5, 1.2, scaleFactor)
        let duration = gsap.utils.interpolate(8, 9, 1 - scaleFactor)
        let opacity = gsap.utils.interpolate(0.8, 1, scaleFactor)
        gsap.set(flake, { y: -100, x: gsap.utils.random(0, width), scale: scale, opacity: opacity })
        gsap.to(flake, {
            y: height + 200,
            x: "+=random(-100, 100)",
            duration: duration,
            delay: "random(0,8)",
            ease: "none",
            rotation: "random(-60, 200)",
            onComplete: animateFlake,
            onCompleteParams: [flake]
        })
    }

    for (let i = 0; i < numFlakes; i++) {
        let flake = createFlake()
        animateFlake(flake)
    }

    //document.addEventListener("click", () => gsap.globalTimeline.paused(!gsap.globalTimeline.paused()))

})